import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ElanController from '../../api/elan/ElanController';
import UserController from '../../api/user/UserController';
import './Elan.css';
import moment from 'moment';
import 'moment/locale/az';
import BoostModal from '../../components/BoostModal'; // Yolu uyğun dəyiş
import axios from 'axios';
import LotoreyaController from '../../api/lotoreya/LotoreyaController';

const Elan = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [elan, setElan] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [contact, setContact] = useState(null);
  const [user, setUser] = useState(null);
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [lotoreyas, setLotoreyas] = useState([]);
  const [showBoostModal, setShowBoostModal] = useState(false);
  const [selectedBoostOption, setSelectedBoostOption] = useState(null);
  const [showLotoreyaConfirmModal, setShowLotoreyaConfirmModal] = useState(false);
  const [showLotoreyaSuccessModal, setShowLotoreyaSuccessModal] = useState(false);
  const [isElanInLotoreya, setIsElanInLotoreya] = useState(false);

  const currentUserId = parseInt(localStorage.getItem('motoTaksiUserId'));

  useEffect(() => {
    const loadElan = async () => {
      try {
        const response = await ElanController.getElanById(id);
        setElan(response);

        if (response.userId) {
          const userResponse = await UserController.getUserById(response.userId);
          setContact(userResponse);
        }
      } catch (error) {
        console.error('Elan yüklənərkən xəta:', error);
      } finally {
        setIsLoading(false);
      }
    };
    loadElan();
  }, [id]);

  // Fetch lotoreya data
  useEffect(() => {
    const loadLotoreyas = async () => {
      try {
        const response = await LotoreyaController.getAllLotoreyas();
        setLotoreyas(response);  // Store lotoreyas data in the state
      } catch (error) {
        console.error('Lotoreya məlumatları yüklənərkən xəta:', error);
      }
    };
    loadLotoreyas();
  }, []);

  useEffect(() => {
    const checkElanInLotoreya = async () => {
      try {
        const allLotoreyas = await LotoreyaController.getAllLotoreyas();
        const exists = allLotoreyas.some(l => l.elanId === elan.id);
        setIsElanInLotoreya(exists);
      } catch (error) {
        console.error('Lotoreya yoxlanarkən xəta:', error);
      }
    };

    if (elan) {
      checkElanInLotoreya();
    }
  }, [elan]);

  const handleOpenLotoreyaConfirmModal = () => {
    setShowLotoreyaConfirmModal(true);
  };

  useEffect(() => {
    const loadUser = async () => {
      try {
        const userId = localStorage.getItem('motoTaksiUserId');
        if (userId) {
          const userData = await UserController.getUserById(userId);
          setUser(userData);
        }
      } catch (err) {
        console.error('İstifadəçi məlumatı yüklənərkən xəta:', err);
      }
    };

    loadUser();
  }, []);

  const handleBoostAd = () => {
    setShowBoostModal(true);
  };

  // Function to handle lotoreya status
  const handleLotoreyaStatus = (elanId) => {
    const matchingLotoreya = lotoreyas.find(l => l.elanId === elanId);
    if (matchingLotoreya) {
      if (matchingLotoreya.carx === null) {
        return matchingLotoreya.isAccept ? 'accepted' : 'pending';
      } else {
        return 'completed';
      }
    } else {
      return 'none';
    }
  };

  const handleSelectBoost = async (option) => {
    try {
      setShowBoostModal(false);
      setSelectedBoostOption(option);

      const userId = localStorage.getItem('motoTaksiUserId');
      if (!user || !user.balance || user.balance < option.price) {
        setShowBalanceModal(true);
        return;
      }

      // Əgər artıq premiumdursa, var olan expireDate üzərinə əlavə et
      const currentExpire = elan.premium && elan.expireDate
        ? moment(elan.expireDate)
        : moment(); // əks halda indidən başla

      const newExpire = currentExpire.clone().add(option.days, 'days');

      await ElanController.updateElan(elan.id, {
        premium: true,
        expireDate: newExpire.toISOString(),
      });

      const updatedUser = {
        ...user,
        balance: user.balance - option.price,
      };
      await UserController.updateUser(userId, updatedUser);
      setUser(updatedUser);

      setElan(prev => ({
        ...prev,
        premium: true,
        expireDate: newExpire.toISOString(),
      }));

      alert(`${option.days} gün əlavə edildi!\nYeni bitmə tarixi: ${newExpire.locale('az').format('LL, HH:mm')}`);
    } catch (error) {
      console.error('Boost zamanı xəta:', error);
      alert('Elanı boost etmək mümkün olmadı.');
    }
  };

  const handleRedirectToPayment = async () => {
    try {
      const userId = localStorage.getItem('motoTaksiUserId');
      const amount = selectedBoostOption?.price || 1; // default 5 AZN əgər selection yoxdursa

      const response = await axios.post('https://mototaksi.az:9898/api/v5/payment-init', {
        amount: amount,
        orderId: `balansmototaksiaz_${userId}_${Date.now()}`,
        description: 'Elan irəli çəkmə üçün balans artırılması',
        successUrl: `https://mototaksi.az/success?userId=${userId}&amount=${amount}&type=balansmototaksiaz`,
        errorUrl: `https://mototaksi.az/error`
      });

      const redirectUrl = response.data;

      if (redirectUrl) {
        setShowBalanceModal(false);
        window.open(redirectUrl, '_blank');
      } else {
        alert('Ödəniş linki alınmadı.');
      }
    } catch (err) {
      console.error('Balans artırma yönləndirməsində xəta:', err);
      alert('Ödəniş səhifəsinə keçid mümkün olmadı.');
    }
  };

  const handleDelete = async () => {
    const confirmed = window.confirm("Bu elanı silmək istədiyinizə əminsiniz?");
    if (confirmed) {
      try {
        await ElanController.deleteElanById(id);
        alert("Elan silindi.");
        navigate("/profile"); // Yönləndirmə profilə və ya ana səhifəyə
      } catch (error) {
        console.error("Elan silinərkən xəta:", error);
        alert("Elanı silmək mümkün olmadı.");
      }
    }
  };

  const handleEdit = () => {
    navigate(`/edit-elan/${id}`);
  };

  const handleAddLotoreya = async () => {
    try {
      const userId = localStorage.getItem('motoTaksiUserId');

      const lotoreyaData = {
        userId: parseInt(userId), // 💥 düz olmalıdır (userId olaraq)
        elanId: elan.id,          // 💥 düz olmalıdır (elanId olaraq)
        isAccept: false
      };

      const response = await LotoreyaController.createLotoreya(lotoreyaData);

      if (response) {
        // ✅ Success modal açılır
        setShowLotoreyaSuccessModal(true);

        // ✅ WhatsApp yönləndirmə
        const adminPhoneNumber = '994709559984';
        const message = `Salam, mən mototaksi.az saytında öz elanımı lotoreyaya əlavə etdim. Zəhmət olmasa, sorğumu nəzərdən keçirəsiniz.\nYoxlanış linki: https://mototaksi.az/private/lotoreya/istekler/${elan.id}`;

        const whatsappLink = `https://wa.me/${adminPhoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(whatsappLink, '_blank');
      } else {
        throw new Error("Serverdən düzgün cavab alınmadı.");
      }
    } catch (error) {
      console.error("❌ Lotoreyaya əlavə edərkən xəta:", error);
      alert("Xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.");
    }
  };

  if (isLoading) {
    return <div>Yüklənir...</div>;
  }

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';

    let cleanedNumber = phone.replace(/\D/g, ''); // Rəqəmlərdən başqa hər şeyi sil

    if (cleanedNumber.startsWith('0')) {
      cleanedNumber = '994' + cleanedNumber.substring(1); // 0-ı at, 994 əlavə et
    } else if (cleanedNumber.startsWith('994')) {
      // artıq düz formatdadır
    } else if (cleanedNumber.startsWith('4') || cleanedNumber.length === 9) {
      // ola bilər ki, lokal nömrə verilib (050123456 gibi)
      cleanedNumber = '994' + cleanedNumber;
    } else if (cleanedNumber.startsWith('')) {
      cleanedNumber = '994' + cleanedNumber;
    }

    return cleanedNumber;
  };

  return (
    <div className="elan-container">
      <div className="elan-header">
        <div className="elan-image-wrapper" style={{ position: 'relative' }}>
          <img src={elan.image} alt={elan.title} className="elan-image" />

          {/* Display Lotoreya Badge based on status */}
          {handleLotoreyaStatus(elan.id) === 'pending' && (
            <div
              className="lotoreya-badge-on-image"
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                backgroundColor: '#ff2b74',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: 'bold'
              }}
            >
              Lotoreya Sorğusu Gözləyir
            </div>
          )}

          {handleLotoreyaStatus(elan.id) === 'accepted' && (
            <div
              className="lotoreya-badge-on-image"
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                backgroundColor: '#f44336', // Red background color
                color: 'white',
                padding: '4px 8px',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: 'bold'
              }}
            >
              Lotoreyada
            </div>
          )}

          {handleLotoreyaStatus(elan.id) === 'completed' && (
            <div
              className="lotoreya-badge-on-image"
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                backgroundColor: '#9e9e9e',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: 'bold'
              }}
            >
              Lotoreya Başa Çatıb
            </div>
          )}
        </div>

        <div className="elan-info">
          <h2 className="elan-title">{elan.title}</h2>
          <p className="elan-price">{elan.price} ₼</p>
          <div className="elan-meta">
            <span>{moment(elan.createdAt).locale('az').format('LL, HH:mm')}</span>

            {elan.premium && (
              <div className="premium-meta">
                <span className="premium-badge">PREMIUM</span>
                {elan.userId === currentUserId && elan.expireDate && (
                  <span className="premium-expire">
                    Premium Elanın Bitmə tarixi: {moment(elan.expireDate).locale('az').format('LL, HH:mm')}
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="elan-body">{elan.description}</div>

          <div className="elan-footer">
            <div className="contact-info">
              <div className="contact-person">
                <span><strong>Əlaqə:</strong></span>
                <span>{contact ? contact.name : 'Yüklənir...'}</span>
                <span>{contact ? contact.phoneNumber : 'Yüklənir...'}</span>
              </div>
            </div>
          </div>

          {showBoostModal && (
            <BoostModal
              onClose={() => setShowBoostModal(false)}
              onSelect={handleSelectBoost}
            />
          )}

          {showLotoreyaSuccessModal && (
            <div className="modal-backdrop">
              <div className="modal-content">
                <h3>✅ Sorğunuz uğurla göndərildi</h3>
                <p>Biraz gözləməyiniz xahiş olunur. Admin tərəfindən yoxlanacaq.</p>
                <button
                  className="confirm-btn"
                  onClick={() => setShowLotoreyaSuccessModal(false)}
                >
                  Bağla
                </button>
              </div>
            </div>
          )}

          {showLotoreyaConfirmModal && (
            <div className="modal-backdrop">
              <div className="modal-content">
                <h3>Lotoreya Qaydaları</h3>
                <p>
                  • Elanınız lotoreya bölməsinə əlavə ediləcək və admin tərəfindən yoxlanacaq. <br />
                  • Qaydalar: Qalib, bilet qiyməti və tarix admin tərəfindən əlavə ediləcək. <br />
                  • İstənilən vaxt admin tərəfindən təsdiq və ya rədd edilə bilər.
                </p>
                <p>
                  Davam etmək istəyirsiniz?
                </p>
                <button
                  className="confirm-btn"
                  onClick={async () => {
                    setShowLotoreyaConfirmModal(false); // Əvvəl modalı bağla
                    await handleAddLotoreya(); // Sonra sorğunu göndər
                  }}
                >
                  Əlavə et
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => setShowLotoreyaConfirmModal(false)}
                >
                  Ləğv et
                </button>
              </div>
            </div>
          )}

          {showBalanceModal && (
            <div className="modal-backdrop">
              <div className="modal-content">
                <h3>Balans kifayət etmir</h3>
                <p>Elanı irəli çəkmək üçün {selectedBoostOption?.price} ₼ tələb olunur.</p>
                <button className="confirm-btn" onClick={handleRedirectToPayment}>
                  Balansı artır
                </button>
                <button className="cancel-btn" onClick={() => setShowBalanceModal(false)}>
                  Bağla
                </button>
              </div>
            </div>
          )}

          <div className="elan-actions">
            <button className="boost-btn" onClick={handleBoostAd}>Elanı irəli çək</button>

            {contact && contact.phoneNumber && (
              <>
                <a className="call-btn" href={`tel:${contact.phoneNumber}`}>Zəng et</a>

                <a
                  className="whatsapp-btn"
                  href={`https://wa.me/${formatPhoneNumber(contact.phoneNumber)}?text=${encodeURIComponent(
                    `Salam, mən sizin elanı mototaksi.az saytında gördüm. Elan hələ də aktivdir?\nhttps://mototaksi.az/elan/${elan.id}`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Whatsapp ilə əlaqə
                </a>

                {elan.userId === currentUserId && (
                  <>
                    {(elan.category === 'taxi' || elan.category === 'rent') ? (
                      <div style={{ textAlign: 'center', marginTop: '10px' }}>
                        <button className="lottery-btn disabled" disabled>
                          ⚠️ Lotoreya üçün uyğun deyil
                        </button>
                        <p style={{ marginTop: '6px', color: '#888', fontSize: '14px' }}>
                          Lotoreyaya sadəcə <strong>Alqı-satqı</strong> və <strong>Zapçast</strong> kateqoriyasında olan elanlar əlavə edilə bilər.
                        </p>
                      </div>
                    ) : (
                      <button
                        className={`lottery-btn ${isElanInLotoreya ? 'disabled' : ''}`}
                        onClick={!isElanInLotoreya ? handleOpenLotoreyaConfirmModal : undefined}
                        disabled={isElanInLotoreya}
                      >
                        {isElanInLotoreya ? (
                          <>
                            <span style={{ marginRight: '6px' }}>⏳</span> Lotoreya Sorğusu göndərilib
                          </>
                        ) : (
                          'Elanı Lotoreyaya əlavə et'
                        )}
                      </button>
                    )}
                  </>
                )}

              </>
            )}

            {/* Əgər bu istifadəçinin öz elanıdırsa, düzəliş və sil düymələrini göstər */}
            {elan.userId === currentUserId && (
              <div className="owner-actions">
                <button className="edit-btn" onClick={handleEdit}>Düzəliş et</button>
                <button className="delete-btn" onClick={handleDelete}>Sil</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Elan;

